module.exports = __webpack_public_path__ + "static/media/in-progress.6e7f6878.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/in-progress.svg
 ** module id = 474
 ** module chunks = 0
 **/